export default __webpack_public_path__ + "static/media/566.5b8621dd.jpg";